module.exports = __webpack_public_path__ + "img/xiaochengxu.54bd777a.jpg";